import { Link } from 'react-router-dom'

/**
 * Displays a selected record's details with a clear button
 */
function RecordCard({ record, label, onClear }) {
  if (!record) return null

  return (
    <div className='bg-gray-50 rounded border p-4'>
      <div className='mb-2 flex justify-between'>
        <h3 className='font-semibold'>{label}</h3>
        <button onClick={onClear} className='text-red-500 text-sm hover:underline'>
          Clear
        </button>
      </div>
      <p>
        <span className='font-semibold'>Type:</span>{' '}
        {record.mediaType
          ? record.mediaType.charAt(0).toUpperCase() + record.mediaType.slice(1)
          : 'Unknown'}
      </p>
      <p>
        <span className='font-semibold'>Title:</span> {record.title}
      </p>
      <p>
        <span className='font-semibold'>Artists:</span> {record.artists?.join(', ') || 'Unknown'}
      </p>
      <p>
        <span className='font-semibold'>Service:</span> {record.service || 'Unknown'}
      </p>
      <p>
        <span className='font-semibold'>Cloud ID:</span> {record.cloudId || 'None'}
      </p>
      <p>
        <span className='font-semibold'>Pending ID:</span> {record.pendingId || 'None'}
      </p>

      <Link
        to={`/admin/reconciliation/record/${record.id}`}
        className='text-blue-500 mt-2 block text-sm hover:underline'
      >
        View Details
      </Link>
    </div>
  )
}

export default RecordCard
